import {configureStore, createSlice, ThunkAction, getDefaultMiddleware} from '@reduxjs/toolkit';
import {Action} from 'redux';
import NewFrontReducer from './reducers/NewFrontReducer';
import TeamReducer from './reducers/TeamReducer';
import ChosenPlayersReducer, { ChosenPlayersSlice } from './reducers/ChosenPlayersReducer'
import { persistedReducer } from './PersistedStore';
import SingleMatchReducer from './reducers/SingleMatchReducer';
import PositionReducer from './reducers/PositionReducer';
import SearchReducer from './reducers/SearchReducer';
import UserSettingsReducer from './reducers/UserSettingsReducer';
import SCTeamsReducer from './reducers/SCTeamsReducer';
import findPlayersReducer from './reducers/FindPlayersReducer';
import SinglePlayerReducer from './reducers/SinglePlayerReducer'
const makeStore = () =>
    configureStore({
        reducer: {
            'chosenplayers': ChosenPlayersReducer,
            'user': UserSettingsReducer,
            'front': NewFrontReducer,
            'team': TeamReducer,
            'singlematch': SingleMatchReducer,
            'position': PositionReducer,
            'search': SearchReducer,
            'findplayers': findPlayersReducer,
            'sc': SCTeamsReducer,
            'singleplayer': SinglePlayerReducer,
        },
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware({
                serializableCheck: false,
            }),
            devTools: true,
    });

export const store2 = configureStore({
    reducer: {
        'chosenplayers': ChosenPlayersReducer,
        'user': UserSettingsReducer,
        'front': NewFrontReducer,
        'team': TeamReducer,
        'singlematch': SingleMatchReducer,
        'position': PositionReducer,
        'search': SearchReducer,
        'findplayers': findPlayersReducer,
        'sc': SCTeamsReducer,
        'singleplayer': SinglePlayerReducer,
    },
    devTools: true,
});

export type AppDispatch = typeof store2.dispatch;
export type RootState = ReturnType<typeof store2.getState>;
export type AppStore = ReturnType<typeof makeStore>;
export type AppState = ReturnType<AppStore['getState']>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action>;

export const wrapper = makeStore;
